import '../leftSide/LeftNewsSection.scss'

import { chakra, Text } from '@chakra-ui/react'
import ReactMarkdown from 'react-markdown'

import useColorModeValue from '@/hooks/useColorModeValue'

const NewsMarkdownRenderer = ({ text }: { text: string }) => {
    const headingColor = useColorModeValue('var(--chakra-colors-dark-700)', 'var(--chakra-colors-white)')
    return (
        <ReactMarkdown
            components={{
                h2: (props) => <Text as="h2" fontSize="21px" fontWeight={700} color={headingColor} mb={3} mt={6} {...props} />,
                em: (props) => <chakra.span fontSize="md" fontWeight="bold" {...props} />,
                p: ({ children, ...props }) => (
                    <Text mb={3} lineHeight="tall" {...props} className="leftNewsSection-intro">
                        {children}
                    </Text>
                ),
            }}
        >
            {text}
        </ReactMarkdown>
    )
}

export default NewsMarkdownRenderer
